import { atomFamily } from "recoil";

export const testResultAtomFamily = atomFamily({
    key: "testresult",
    default: "",
});

export const testProjectAtomFamily = atomFamily({
    key: "testresultproject",
    default: null,
});
